/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Gh_Err_TokenInputs */

const en_adm_gh_err_token = /** @type {(inputs: Adm_Gh_Err_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No GitHub token found. Enter one above or set GITHUB_TOKEN on the server.`)
};

const de_adm_gh_err_token = /** @type {(inputs: Adm_Gh_Err_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein GitHub-Token gefunden. Gib oben eines ein oder setze GITHUB_TOKEN auf dem Server.`)
};

/**
* | output |
* | --- |
* | "No GitHub token found. Enter one above or set GITHUB_TOKEN on the server." |
*
* @param {Adm_Gh_Err_TokenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_gh_err_token = /** @type {((inputs?: Adm_Gh_Err_TokenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Gh_Err_TokenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_gh_err_token(inputs)
	return en_adm_gh_err_token(inputs)
});